import React from "react";
import { withTheme } from "../../../hoc";
import {
  SectionDetailsStyle,
  DetailsArea,
  Summary,
  Data,
  Details,
  FileContainer,
} from "./style";
import { ReactComponent as FileIcon } from "../../../assets/images/svgs/file-icon.svg";
import Button from "../Button";
import { ButtonState } from "../Button/types/buttonState";
// import { convertDSAToPDF } from "../../../utils/helpers/index";

const SectionDetails = ({
  title,
  summary,
  columnOne,
  columnTwo,
  showFile = false,
  fileDescription,
  identification,
  identificationFileName,
  ...props
}) => {
  return (
    <SectionDetailsStyle>
      <h5>{title}</h5>
      <DetailsArea>
        <Summary>{summary}</Summary>
        <div>
          {showFile && (
            <div>
              <p>{"Notification of Result"}</p>
              <FileContainer>
                <FileIcon />
                <p>
                  {identification &&
                  props.notificationOfResult !== "false" &&
                  props.studentIdCard !== null
                    ? "Notification_of_Result.pdf"
                    : "Not Submitted"}
                </p>
              </FileContainer>
              <br />
              {typeof props.notificationOfResult === "string" &&
              props.notificationOfResult !== "false" ? (
                <a
                  href={props.notificationOfResult}
                  target="_blank"
                  download={"Notification_of_Result.pdf"}
                >
                  <Button
                    variant={ButtonState.TERTIARY}
                    padding="10px 20px"
                    disabled={identification ? false : true}
                  >
                    View
                  </Button>
                </a>
              ) : (
                <Button
                  variant={ButtonState.TERTIARY}
                  padding="10px 20px"
                  disabled={identification ? false : true}
                >
                  View
                </Button>
              )}
            </div>
          )}

          {showFile && (
            <div>
              <p>{"Student ID Card"}</p>
              <FileContainer>
                <FileIcon />
                <p>
                  {identification &&
                  props.studentIdCard !== "false" &&
                  props.studentIdCard !== null
                    ? "Student_ID_Card.pdf"
                    : "Not Submitted"}
                </p>
              </FileContainer>
              <br />
              {typeof props.studentIdCard === "string" &&
              props.notificationOfResult !== "false" ? (
                <a
                  href={props.studentIdCard}
                  download={"student_Id_card.pdf"}
                  target="_blank"
                >
                  <Button
                    variant={ButtonState.TERTIARY}
                    padding="10px 20px"
                    disabled={identification ? false : true}
                  >
                    View
                  </Button>
                </a>
              ) : (
                <Button
                  variant={ButtonState.TERTIARY}
                  padding="10px 20px"
                  disabled={identification ? false : true}
                  // onClick={() =>
                  //   convertDSAToPDF(identification, identificationFileName)
                  // }
                >
                  View
                </Button>
              )}
            </div>
          )}

          {showFile && (
            <div>
              <p>{"Police Report"}</p>
              <FileContainer>
                <FileIcon />
                <p>
                  {props.policeReport ? "police_report.pdf" : "Not Submitted"}
                </p>
              </FileContainer>
              <br />
              {typeof props.policeReport === "string" &&
              props.notificationOfResult !== "false" ? (
                <a
                  href={props.policeReport}
                  download={props.policeReport}
                  target="_blank"
                >
                  <Button
                    variant={ButtonState.TERTIARY}
                    padding="10px 20px"
                    disabled={identification ? false : true}
                  >
                    View
                  </Button>
                </a>
              ) : (
                <Button
                  variant={ButtonState.TERTIARY}
                  padding="10px 20px"
                  disabled={identification ? false : true}
                >
                  View
                </Button>
              )}
            </div>
          )}

          {showFile && (
            <div>
              <p>{"Court Affidavit"}</p>
              <FileContainer>
                <FileIcon />
                <p>
                  {props.courtAffidavit
                    ? "court_affidavit.pdf"
                    : "Not Submitted"}
                </p>
              </FileContainer>
              <br />
              {typeof props.courtAffidavit === "string" &&
              props.notificationOfResult !== "false" ? (
                <a
                  href={props.courtAffidavit}
                  download={props.courtAffidavit}
                  target="_blank"
                >
                  <Button
                    variant={ButtonState.TERTIARY}
                    padding="10px 20px"
                    disabled={identification ? false : true}
                  >
                    View
                  </Button>
                </a>
              ) : (
                <Button
                  variant={ButtonState.TERTIARY}
                  padding="10px 20px"
                  disabled={identification ? false : true}
                >
                  View
                </Button>
              )}
            </div>
          )}

          <Data>
            <div>
              {columnOne?.map((data, i) => (
                <Details key={i}>
                  <p>{`${data.title}:`}</p>
                  <span>{data.value}</span>
                </Details>
              ))}
            </div>
            <div>
              {columnTwo?.map((data, i) => (
                <Details key={i}>
                  <p>{`${data.title}:`}</p>
                  <span>{data.value}</span>
                </Details>
              ))}
            </div>
          </Data>
        </div>
      </DetailsArea>
    </SectionDetailsStyle>
  );
};

export default withTheme(SectionDetails);
